var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{class:_vm.divClass},[(_vm.type === 'error')?_c('message-error',{attrs:{"message":_vm.message}}):(_vm.type === 'success')?_c('message-success',{attrs:{"message":_vm.message}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }